export const newOrderActionTypes = {
  setObservations: '[NewOrder] Set observations',
  addSpecialRequest: '[NewOrder] Add special request',
  setAlternativeOwner: '[NewOrder] Add alternative owner',
  setPromiseDate: '[NewOrder] set promise date',
  updateCreatedDate: '[NewOrder] update created date',
  changeCompletionType: '[NewOrder] Change completion type',
  removeSpecialRequest: '[NewOrder] Remove special request',
  openEditVehicleModal: '[NewOrder] Open edit vehicle modal',
  closeEditVehicleModal: '[NewOrder] close edit vehicle modal',
  setSelectedVendor: '[NewOrder] Set selected vendor',
  clearNewOrder: '[NewOrder] Clear new order',
  discardOrder: '[NewOrder] Discard order',
  clearError: '[NewOrder] Clear error',
  addPriceToSelectedPrices: '[NewOrder] Add price to selected prices',
  removePriceToSelectedPrices: '[NewOrder] Remove price to selected prices',
  getVendors: '[NewOrder] Get vendors async',
  getServicesByDepartment: '[NewOrder] Get services by department',
  getVehicleByVin: '[NewOrder] Get vehicle by vin',
  saveNewOrder: '[NewOrder] Save new order',
  editVehicleDetails: '[NewOrder] Edit vehicle details',
  addVehicleDetails: '[NewOrder] Add vehicle details',
  alternativeOwner: '[NewOrder] alternative owner',
  setAllDealers: '[NewOrder] Set all dealers',
  setStockNumber: '[NewOrder] set searched vehicle stock number',
};
